/*** IMPORTS FROM imports-loader ***/
(function() {

    define(['jquery', 'pip-common.utils', 'moment', 'pip-model'], function ($, pipUtils, moment, pip) {

    var statusMessaging = {
        AVAILABLE: 'AVAILABLE',
        BACK_ORDERED: 'BACK_ORDERED',
        OUT_OF_STOCK: 'OOS_',
        UNAVAILABLE: 'UNAVAILABLE'
    }

    function processData(data) {
        if (!data
            || !data.deliveryAvailabilityResponse
            || !data.deliveryAvailabilityResponse.deliveryAvailability
            || !data.deliveryAvailabilityResponse.deliveryAvailability.availability
            || data.deliveryAvailabilityResponse.errorModel) {
            return {
                isError: true
            };
        }

        return {
            sku: data.deliveryAvailabilityResponse.deliveryAvailability.availability.itemId,
            zipCode: data.deliveryAvailabilityResponse.deliveryAvailability.zipCode,
            backOrderedEstimatedDeliveryDate: moment(data.deliveryAvailabilityResponse.deliveryAvailability.availability.etaDate).format('MMM Do, YYYY'),
            rawBackOrderedEstimatedDeliveryDate: data.deliveryAvailabilityResponse.deliveryAvailability.availability.etaDate,
            deliveryDate: moment(data.deliveryAvailabilityResponse.deliveryAvailability.earliestAvailabilityDate || checkEarliestDeliveryDate(data.deliveryAvailabilityResponse.deliveryAvailability.deliveryInfo)).format('MMM Do, YYYY'),
            rawDeliveryDate: data.deliveryAvailabilityResponse.deliveryAvailability.earliestAvailabilityDate || checkEarliestDeliveryDate(data.deliveryAvailabilityResponse.deliveryAvailability.deliveryInfo),
            endDeliveryDate: moment(getLatestDeliveryDate(data.deliveryAvailabilityResponse.deliveryAvailability.deliveryInfo)).format('MMM Do, YYYY'),
            rawEndDeliveryDate: getLatestDeliveryDate(data.deliveryAvailabilityResponse.deliveryAvailability.deliveryInfo),
            isAvailable: data.deliveryAvailabilityResponse.deliveryAvailability.availability.status === statusMessaging.AVAILABLE,
            isBackOrdered: data.deliveryAvailabilityResponse.deliveryAvailability.availability.status === statusMessaging.BACK_ORDERED,
            isOutOfStock: data.deliveryAvailabilityResponse.deliveryAvailability.availability.status.indexOf(statusMessaging.OUT_OF_STOCK) === 0,
            isUnavailable: data.deliveryAvailabilityResponse.deliveryAvailability.availability.status === statusMessaging.UNAVAILABLE,
        }
    }

    function processDataV3(data) {
        if (!data
            || !data.DeliveryAvailabilityResponse
            || !data.DeliveryAvailabilityResponse.deliveryAvailability
            || !data.DeliveryAvailabilityResponse.deliveryAvailability.availability
            || data.DeliveryAvailabilityResponse.errorData) {
            return [{
                isError: true
            }];
        }

        return data.DeliveryAvailabilityResponse.deliveryAvailability.availability.map(function (item) {
            return {
                sku: item.itemId,
                zipCode: data.DeliveryAvailabilityResponse.deliveryAvailability.zipCode,
                rawBackOrderedEstimatedDeliveryDate: item.etaDate,
                backOrderedEstimatedDeliveryDate: item.etaDate == null ? '' : moment(item.etaDate).format('MMM Do, YYYY'),
                deliveryDate: moment(data.DeliveryAvailabilityResponse.deliveryAvailability.earliestAvailabilityDate).format('MMM Do, YYYY'),
                rawDeliveryDate: data.DeliveryAvailabilityResponse.deliveryAvailability.earliestDeliveryDate,
                primaryStoreNumber: data.DeliveryAvailabilityResponse.deliveryAvailability.primaryStrNbr,
                endDeliveryDate: moment(getLatestDeliveryDate(data.DeliveryAvailabilityResponse.deliveryAvailability.deliveryInfo)).format('MMM Do, YYYY'),
                isAvailable: item.status === statusMessaging.AVAILABLE,
                isBackOrdered: item.status === statusMessaging.BACK_ORDERED,
                isOutOfStock: item.status.indexOf(statusMessaging.OUT_OF_STOCK) === 0,
                isUnavailable: item.status === statusMessaging.UNAVAILABLE,
                message: '',
            }
        })
    }


    function checkEarliestDeliveryDate(deliveryInfo) {
        var eligibleSlots = deliveryInfo.filter(function (delivery) {
            return delivery.slotsAvailable > 0;
        });
        return eligibleSlots[0] && eligibleSlots[0].date;
    }

    function getLatestDeliveryDate(deliveryInfo) {
        if (!deliveryInfo || !deliveryInfo.length) return;
        var eligibleSlots = deliveryInfo.filter(function (delivery) {
            return delivery.slotsAvailable > 0;
        });
        return eligibleSlots[eligibleSlots.length-1].date;
    }

    function makeApplianceAvailabilityCall(itemId, zipCode) {
        var xURL = 'https://' + pip.remoteHosts.secureBrowse + '/mcc-cart/v2/appliance/productAvailability';
        return $.ajax({
            type: "GET",
            url: pipUtils.buildURLWithParams(xURL,
                {
                    itemId: itemId,
                    zipCode: zipCode
                }),
            cache: false,
            dataType: "json"
        })
    }

    function makeApplianceAvailabilityCallV3(itemIds, zipCode) {
        var xURL = 'https://' + pip.remoteHosts.secureBrowse + '/mcc-cart/v3/appliance/deliveryAvailability/'+itemIds+'/zipCode/'+zipCode;

        if (pip.features &&
            pip.features.llcMockDataServiceEnabled &&
            pip.mockServicesData &&
            pip.mockServicesData.applianceAvailability) {

          xURL = '/p/mockData/json/applianceAvailability?fileName=' + pip.mockServicesData.applianceAvailability;
        }

        return $.ajax({
            type: "GET",
            url: xURL,
            cache: false,
            dataType: "json"
        })
    }

    return {
        getApplianceAvailability: function (itemId, zipCode) {
            var dfd = $.Deferred();
            makeApplianceAvailabilityCallV3(itemId, zipCode)
                .done(function (data) {
                    dfd.resolve({
                        rawResponse: data,
                        processedResponse: processDataV3(data)
                    });
                })
                .fail(function (data) {
                    dfd.reject({
                        rawResponse: data,
                        processedResponse: [{
                            isError: true
                        }]
                    });
                });
            return dfd;
        },
        processData: processData,
        processDataV3: processDataV3,
        checkEarliestDeliveryDate: checkEarliestDeliveryDate,
        getLatestDeliveryDate: getLatestDeliveryDate
    }

})

}.call(window));